// This is your plugin object. It can be exported to be used anywhere.
const MyPlugin = {
  // The install method is all that needs to exist on the plugin object.
  // It takes the global Vue object as well as user-defined options.
  install (Vue, options) {
    // params doit être un tableau de string contenant les valeurs à remplacer
    Vue.prototype.$resx = function (key, params) {
      var res = this.$store.state.app.translations[key]

      if (params !== undefined && params !== null && params.length > 0) {
        res = stringFormat(res, params)
      }
      return res
    }
  }
}

function stringFormat (str, arr) {
  return str.replace(
    /\{([0-9]+)\}/g,
    function (_, index) { return arr[index] })
}

export default MyPlugin
